"use client";

import { useEffect } from 'react';
import { useCookieConsent } from './CookieConsent';

export function GoogleAnalyticsInit() {
  const { hasConsent } = useCookieConsent();
  const GOOGLE_ANALYTICS_ID = 'G-7QX695K229';

  const gtag = (...args: any[]) => {
    if (typeof window !== 'undefined') {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(args);
    }
  }

  gtag('js', new Date());
  gtag('config', GOOGLE_ANALYTICS_ID);
  
  useEffect(() => {
    // Only initialize if user has consented (default: true)
    if (hasConsent === false && typeof window !== 'undefined') {
        gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied'
        });
    }
  }, [hasConsent]);

  return null;
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    dataLayer: any[];
  }
}

